/**
 *
 * Asynchronously loads the Masking Policies container
 *
 */

import { lazy } from 'react';

export const MaskingPolicies = lazy(() =>
  import('./index').then(module => ({ default: module.MaskingPolicies })),
);
